import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';
import SDKMessageBus from '../utility/message-bus';

export interface IOverpanelOptions {
    fullWidth?: boolean;
    size?: 'small' | 'medium' | 'large' | 'full';
}

export default function showOverpanelSetup(
    messageBus: SDKMessageBus,
    moduleId: string,
    capabilities: Set<string>
) {
    if (!capabilities.has('showOverpanel') || moduleId.includes('tectonOverpanel')) {
        return;
    }

    return function showOverpanel<T>(
        overpanelPath: string,
        params?: IDict<string>,
        options?: IOverpanelOptions,
        useRouteConfig?: boolean
    ): Promise<T> {
        const body = Maybe.maybe({
            moduleId,
            params,
            overpanelPath,
            options,
            useRouteConfig
        }).map(JSON.stringify);
        return messageBus.sendRequest<T>('showOverpanel', body).then(response => response.value);
    };
}
